import App from './App.svelte';
import './main.css';

var app = new App({
  target: document.body
});

export default app;
